import React, { useState, useEffect } from "react"
import { Row, Col, Button, Modal, ModalHeader, ModalBody, Form, FormGroup, Label, Input } from "reactstrap"
import Datatables from "components/Datatables/datatable"
import { get, post } from "helpers/api_helper"
import { PAYROLL_UNDERTIME_URL } from "helpers/url_helper"
import Notifications from "components/Notifications"

const UnderTime = () => {
    const [modal, setModal] = useState(false)
    const [isEdit, setIsEdit] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [dataRows, setDataRows] = useState({ rows: [], total_rows: 0 })
    
    const [formData, setFormData] = useState({
        title: "",
        deduction_multiplier: "1.0"
    })

    const toggleModal = () => {
        if (modal) {
            setFormData({ title: "", deduction_multiplier: "1.0" })
            setIsEdit(false)
        }
        setModal(!modal)
    }

    const brownBtnStyle = { backgroundColor: "#3d1e08", borderColor: "#3d1e08", color: "#fff" }

    const getData = async () => {
        setIsLoading(true)
        const res = await get(PAYROLL_UNDERTIME_URL)
        if (res.status === 200) {
            setDataRows(res.response)
        }
        setIsLoading(false)
    }

    useEffect(() => {
        getData()
    }, [])

    const handleSubmit = async (e) => {
        e.preventDefault()
        const res = isEdit 
            ? await post(`${PAYROLL_UNDERTIME_URL}_update`, formData)
            : await post(PAYROLL_UNDERTIME_URL, formData)
            
        if (res.status === 200 || res.status === true) {
            Notifications("success", res.message)
            toggleModal()
            getData()
        } else {
            Notifications("error", res.message)
        }
    }

    const handleEdit = (row) => {
        setFormData({ ...row })
        setIsEdit(true)
        setModal(true)
    }

    const handleDelete = async (id) => {
        if (window.confirm("Are you sure you want to delete this undertime rule?")) {
            const res = await get(`${PAYROLL_UNDERTIME_URL}_delete?id=${id}`)
            if (res.status === 200 || res.status === true) {
                Notifications("success", res.message)
                getData()
            } else {
                Notifications("error", res.message)
            }
        }
    }

    const columns = [
        { dataField: "id", text: "#" },
        { dataField: "title", text: "TITLE" },
        { dataField: "deduction_multiplier", text: "DEDUCTION MULTIPLIER (x)" },
        {
            dataField: "status",
            text: "STATUS",
            formatter: (cell) => (
                <div className="form-check form-switch" dir="ltr">
                    <input type="checkbox" className="form-check-input" defaultChecked={cell == 1} />
                </div>
            )
        },
        {
            dataField: "action",
            text: "ACTION",
            formatter: (cell, row) => (
                <>
                    <Button color="light" size="sm" className="me-1" onClick={() => handleEdit(row)}><i className="far fa-edit text-primary"></i></Button>
                    <Button color="light" size="sm" onClick={() => handleDelete(row.id)}><i className="far fa-times-circle text-danger"></i></Button>
                </>
            )
        }
    ]

    return (
        <React.Fragment>
            <Datatables 
                title="Undertime Management"
                titleClass="h5"
                columns={columns} 
                rows={dataRows.rows} 
                keyField="id" 
                isSearch={false} 
                isAdd={true} 
                btnTitle="Add UT Rule"
                btnColor="success"
                handleAddButton={toggleModal}
                loading={isLoading} 
            />

            <Modal isOpen={modal} toggle={toggleModal} size="lg">
                <ModalHeader toggle={toggleModal}>{isEdit ? "Edit" : "Add"} Undertime Rule</ModalHeader>
                <ModalBody>
                    <Form onSubmit={handleSubmit}>
                        <Row>
                            <Col md={8}>
                                <FormGroup>
                                    <Label>Title <span className="text-danger">*</span></Label>
                                    <Input 
                                        type="text" 
                                        placeholder="e.g. Standard UT Deduction" 
                                        value={formData.title}
                                        onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                                        required
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup>
                                    <Label>Deduction Multiplier <span className="text-danger">*</span></Label>
                                    <Input 
                                        type="number" 
                                        step="0.1"
                                        placeholder="e.g. 1.0" 
                                        value={formData.deduction_multiplier}
                                        onChange={(e) => setFormData({ ...formData, deduction_multiplier: e.target.value })}
                                        required
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <div className="mt-3">
                            <Button style={brownBtnStyle} type="submit">{isEdit ? "Update" : "Create"}</Button>
                        </div>
                    </Form>
                </ModalBody>
            </Modal>
        </React.Fragment>
    )
}

export default UnderTime
